export const environment = {
  production: true,
  // production backend URL
  apiUrl: 'https://gateway.educanet.pro/api/',
};
